import React, { ReactElement } from 'react'
import KTR603 from '../Clampexsets/KTR603';
import KTR620 from '../Clampexsets/KTR620';
import { makeStyles, Grid } from '@material-ui/core';

const useStyle = makeStyles({
  card: {
    margin: "10px"
  }
});

export default function ExternalClampingset(): ReactElement {
  const classes = useStyle();

  return (
    <React.Fragment>
      <Grid container style={{ marginTop: "20px" }} justify="center">
        <Grid item>
          <KTR603 className={classes.card} />
        </Grid>
        <Grid item >
          <KTR620 className={classes.card} />
        </Grid>
      </Grid>
    </React.Fragment>
  )
}
